import * as React from "react";
import {Route} from "react-router-dom";

import {useLocation} from "@khan/urls";
import {scrollToOffset} from "@khan/util-scrolling";

import RouteLoadSpinner from "./route-load-spinner.tsx";
import type {CommonRouteProps} from "./types.ts";

// NOTE(kevinb): We use lazy with this component so that we avoid having
// to load all of its dependencies and subdependencies on every page.
const TopLevelContentRouteInner = React.lazy(
    () => import("./top-level-content-route-internal.tsx"),
);

export default function TopLevelContentRoute({
    exact,
    path,
    component,
    template,
}: CommonRouteProps): React.ReactElement {
    const {pathname} = useLocation();
    // Scroll to the top of the page on navigation.
    React.useEffect(() => scrollToOffset(0, 0), [pathname]);

    return (
        <Route exact={exact} path={path}>
            <React.Suspense fallback={<RouteLoadSpinner template={template} />}>
                <TopLevelContentRouteInner component={component} />
            </React.Suspense>
        </Route>
    );
}
